<div style="display:show" id="divdata">
    <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
        <h5 class="medium m-0" *ngIf="type == 'ADD'">{{'addJobGrade' | translate}} </h5>
        <h5 class="medium m-0" *ngIf="type == 'EDIT'">{{'editJobGrade' | translate}} </h5>
        <h5 class="medium m-0" *ngIf="type == 'DELETE'">{{'deleteJobGrade' | translate}} </h5>
        <div class="ml-alert">
        </div>
        <div style="flex-grow: 1;"></div>
        <button class="btn btn-secondary" name="backJobGrade" (click)="goToBackPage()">
            <i class="fa fa-arrow-left mr-sm-2"></i> {{'back' | translate}}
        </button>
    </div>
    <div class="col-lg-8 col-md-3">
        <div class="form-group">
            <label> {{'code' | translate}}
                <span class="text-danger medium">*</span>
            </label>
            <input type="text" class="form-control" name="jobGradeCode" placeholder="{{'code' | translate}}"
                   [(ngModel)]="gradedata.gradeCode"
                   [readonly]="type == 'DELETE'" maxlength="250">
            <span class="info-text">({{'maxTwoFifty' | translate}})</span>
        </div>
    </div>
    <div class="col-lg-8 col-md-3">
        <div class="form-group">
            <label> {{'name' | translate}}
                <span class="text-danger medium">*</span>
            </label>
            <input type="text" class="form-control" name="jobGradeName" placeholder="{{'name' | translate}}"
                   [(ngModel)]="gradedata.name"
                   [readonly]="type == 'DELETE'" maxlength="250">
            <span class="info-text">({{'maxTwoFifty' | translate}})</span>
        </div>
    </div>
    <div class="col-lg-8 col-md-3">
        <div class="form-group">
            <label> {{'nameLocale' | translate}}
                <span class="text-danger medium">*</span>
            </label>
            <input type="text" class="form-control" name="jobGradeNameLoc" placeholder="{{'nameLocale' | translate}}"
                   [(ngModel)]="gradedata.nameLocale"
                   [readonly]="type == 'DELETE'" maxlength="250">
            <span class="info-text">({{'maxTwoFifty' | translate}})</span>
        </div>
    </div>
    <div class="col-lg-8 col-md-3">
        <div class="form-group">
            <label> {{'category' | translate}}
            </label>
            <input type="text" class="form-control" name="jobGradeCat" placeholder="{{'category' | translate}}"
                   [(ngModel)]="gradedata.category"
                   [readonly]="type == 'DELETE'" maxlength="250">
            <span class="info-text">({{'maxTwoFifty' | translate}})</span>
        </div>
    </div>
    <div class="col-lg-8 col-md-3">
        <div class="form-group">
            <label> {{'description' | translate}}
            </label>
            <input type="text" class="form-control" name="jobGradeDesc" placeholder="{{'description' | translate}}"
                   [(ngModel)]="gradedata.description"
                   [readonly]="type == 'DELETE'" maxlength="500">
            <span class="info-text">({{'maxFiveHundred' | translate}})</span>
        </div>
    </div>
    <div class="col-lg-8 col-md-3">
        <div class="form-group">
            <label> {{'descriptionLocale' | translate}}
            </label>
            <input type="text" class="form-control" name="jobGradeDescLoc"
                   placeholder="{{'descriptionLocale' | translate}}" [(ngModel)]="gradedata.descriptionLocale"
                   [readonly]="type == 'DELETE'" maxlength="500">
            <span class="info-text">({{'maxFiveHundred' | translate}})</span>
        </div>
    </div>
    <div class="col-lg-8 col-md-3 ">
        <div class="form-group">
            <label> {{'level' | translate}}
                <span class="text-danger medium">*</span>
            </label>
            <input type="number" class="form-control" name="jobGradeLev" placeholder="{{'level' | translate}}"
                   [(ngModel)]="gradedata.level" min="1"
                   [readonly]="type == 'DELETE'">
        </div>
    </div>

    <div class="col-lg-8 col-md-3" *ngIf="type == 'DELETE' && empPresent">
        <div class="form-group">
            <label for="gradeAutoComplete">{{'altJobGrade' | translate}}</label>
            <input ng2-auto-complete autocomplete="off" id='gradeAutoComplete' name='gradeAutoComplete'
                   [(ngModel)]="gradeModel"
                   name="gradeModel" [source]="gradeObservableSource.bind(this)"
                   [list-formatter]="autoCompleteListGradeFormatter"
                   value-property-name="id" display-property-name="displayName"
                   placeholder="{{'typeChooseJObGrade' | translate}}"
                   class="form-control" (valueChanged)="gotNewValue($event)" max-num-list=5
                   [value-formatter]="nameValueFormatter"
                   blank-option-text="Select" [accept-user-input]=false [no-match-found-text]="warning">
            <span class="info-text"> {{'selectJobGrade' | translate}} </span>
        </div>
    </div>
    <div class="col-lg-3 col-md-3">
        <button class="btn btn-primary float-left mt-4" name="jobGradeSave" *ngIf="type == 'ADD'"
                (click)=this.saveGrade()> {{'add' |
            translate}}
        </button>
        <button class="btn btn-primary float-left mt-4" name="jobGradeEdit" *ngIf="type == 'EDIT'"
                (click)=this.saveGrade()>{{'updateChanges' |
            translate}}
        </button>
        <button class="btn btn-primary float-left mt-4" name="jobGradeDel" *ngIf="type == 'DELETE'"
                (click)=this.deleteGrade()> {{'delete' |
            translate}}
        </button>
        <button class="btn btn-secondary float-left mt-4 ml-1" name="jobGradeCan" (click)="goToBackPage()"> {{'cancel' |
            translate}}
        </button>
    </div>

</div>


// WEBPACK FOOTER //
// ./src/app/tools/addGrade.html